import { render, staticRenderFns } from "./TextDescription.vue?vue&type=template&id=a596b7aa&scoped=true&"
import script from "./TextDescription.vue?vue&type=script&lang=js&"
export * from "./TextDescription.vue?vue&type=script&lang=js&"
import style0 from "./TextDescription.vue?vue&type=style&index=0&id=a596b7aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a596b7aa",
  null
  
)

export default component.exports